import { DEFAULT_COUNT_ON_PAGE } from '@shared/ui/pagination/constants';
import { UsersListManagemntDataRequest } from '../api/user-management-types';
import { DefaultSortOptionValues } from '@shared/ui/dropdown-sort/types';

export const DEFAULT_USERS_LIST_PARAMETERS: UsersListManagemntDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
    departments: [],
    sort: DefaultSortOptionValues.Old,
};
